var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class AwaitQueue {
    constructor(name, { ClosedErrorClass = Error, StoppedErrorClass = Error, RemovedTaskErrorClass = Error } = {
        ClosedErrorClass: Error,
        StoppedErrorClass: Error,
        RemovedTaskErrorClass: Error
    }) {
        this.name = name;
        this.closed = false;
        this.pendingTasks = [];
        this.ClosedErrorClass = Error;
        this.StoppedErrorClass = Error;
        this.RemovedTaskErrorClass = Error;
        this.ClosedErrorClass = ClosedErrorClass;
        this.StoppedErrorClass = StoppedErrorClass;
        this.RemovedTaskErrorClass = RemovedTaskErrorClass;
    }
    get size() {
        return this.pendingTasks.length;
    }
    close() {
        if (this.closed)
            return;
        this.closed = true;
        for (const pendingTask of this.pendingTasks) {
            pendingTask.stopped = true;
            pendingTask.reject(new this.ClosedErrorClass(`AwaitQueue ${this.name} closed ${pendingTask.name}`));
        }
        this.pendingTasks.length = 0;
    }
    push(task, name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.closed) {
                throw new this.ClosedErrorClass("AwaitQueue closed");
            }
            if (typeof task !== "function") {
                throw new TypeError("given task is not a function");
            }
            if (!task.name && name) {
                try {
                    Object.defineProperty(task, "name", { value: name });
                }
                catch (_a) { }
            }
            return yield new Promise((resolve, reject) => {
                const pendingTask = {
                    task,
                    name,
                    resolve,
                    reject,
                    stopped: false,
                    enqueuedAt: new Date(),
                    executedAt: undefined
                };
                this.pendingTasks.push(pendingTask);
                // Run it if this is the only task in the queue.
                if (this.pendingTasks.length === 1) {
                    this.next();
                }
            });
        });
    }
    removeTask(idx) {
        if (idx === 0) {
            throw new TypeError("cannot remove task with index 0");
        }
        const pendingTask = this.pendingTasks[idx];
        if (!pendingTask)
            return;
        this.pendingTasks.splice(idx, 1);
        pendingTask.reject(new this.RemovedTaskErrorClass("task removed from the queue"));
    }
    stop() {
        if (this.closed)
            return;
        for (const pendingTask of this.pendingTasks) {
            pendingTask.stopped = true;
            pendingTask.reject(new this.StoppedErrorClass("AwaitQueue stopped"));
        }
        this.pendingTasks.length = 0;
    }
    next() {
        return __awaiter(this, void 0, void 0, function* () {
            const pendingTask = this.pendingTasks[0];
            if (!pendingTask) {
                return;
            }
            yield this.executeTask(pendingTask);
            this.pendingTasks.shift();
            yield this.next();
        });
    }
    executeTask(pendingTask) {
        return __awaiter(this, void 0, void 0, function* () {
            if (pendingTask.stopped)
                return;
            pendingTask.executedAt = new Date();
            try {
                const result = yield pendingTask.task();
                if (pendingTask.stopped)
                    return;
                pendingTask.resolve(result);
            }
            catch (error) {
                if (pendingTask.stopped)
                    return;
                pendingTask.reject(error);
            }
        });
    }
}
